import { Box, Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import { setTransportFilterCheckedType } from 'app/actions/map';
import { useLocalStorage } from 'app/services';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapFilterTransportFilterList = () => {
  const dispatch = useDispatch();
  const checkedType = useSelector((state) => state.map.transportFilterCheckedType);
  const [, setTransportFilterCheckedStorageType] = useLocalStorage('transportFilterCheckedType', 'all');

  const handleChange = (event) => dispatch(setTransportFilterCheckedType(event.target.name));

  useEffect(() => {
    setTransportFilterCheckedStorageType(checkedType);
  }, [checkedType]);

  return (
    <Box
      component='ul'
      sx={(theme) => ({
        display: 'flex',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '10px',
        width: '100%',
        listStyle: 'none',
        position: 'relative',
        padding: '0 12px',
        margin: theme.spacing(0),
        '.MuiFormLabel-root': {
          marginBottom: '6px',
          fontSize: '12px',
          '&.Mui-focused': {
            color: 'text.secondary',
          },
        },
        '.MuiFormControlLabel-root': {
          userSelect: 'none',
          margin: theme.spacing(0),
          padding: theme.spacing(0),
          '.MuiCheckbox-root': {
            padding: theme.spacing(0),
            marginRight: '4px',
          },
        },
        '.MuiFormControlLabel-label': {
          whiteSpace: 'nowrap',
        },
      })}>
      <FormControl component='fieldset' variant='standard'>
        <FormGroup>
          <FormControlLabel
            label='Обычный режим'
            control={<Checkbox size='small' name='all' disableRipple onChange={handleChange} checked={checkedType === 'all'} />}
          />
        </FormGroup>
      </FormControl>
      <FormControl component='fieldset' variant='standard'>
        <FormGroup>
          <FormControlLabel
            label='Режим обработки'
            control={<Checkbox size='small' name='filter' disableRipple onChange={handleChange} checked={checkedType === 'filter'} />}
          />
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default MapFilterTransportFilterList;
